import * as yup from 'yup';

import registerPhoneValidation from 'utils/phoneValidation';

registerPhoneValidation();

export enum Lengths {
  EmailMax = 159,
  PasswordMin = 6,
}

export enum EmailValidationErrors {
  ValidEmail = 'Enter a valid email',
  Required = 'Email is required',
}

export const email = yup
  .string()
  .max(Lengths.EmailMax, EmailValidationErrors.ValidEmail)
  .email(EmailValidationErrors.ValidEmail)
  .required(EmailValidationErrors.Required);

const existingPassword = yup.string().required('Password is required');

const password = existingPassword
  // https://docs.microsoft.com/en-us/aspnet/core/security/authentication/identity-configuration?view=aspnetcore-5.0#:~:text=5-,Password,at%20least%20six%20characters%20long.
  .min(Lengths.PasswordMin, `Use ${Lengths.PasswordMin} or more characters`)
  .matches(RegExp('(.*[a-z].*)'), 'Use at least 1 lower case letter')
  .matches(RegExp('(.*[A-Z].*)'), 'Use at least 1 upper case letter')
  .matches(RegExp('(.*\\d.*)'), 'Use at least 1 number')
  .matches(
    RegExp('[!@#$%^&*(),.?":{}|<>]'),
    'Use at least 1 special character (!@#$%^&*(),.?":{}|<>)'
  );
// .matches(
// /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/,
// 'Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
// );

export const signInValidationSchema = yup.object({
  email,
  password: existingPassword,
  rememberLogin: yup.boolean().default(false),
});

export const verifyAccountValidationSchema = yup.object({ email });

export const resetPasswordValidationSchema = yup.object({ password });

export const registerValidationSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email,
  password,
});

export const acceptTermsAndConditions = yup
  .boolean()
  .required('The terms and conditions must be accepted.')
  .oneOf([true], 'The terms and conditions must be accepted.')
  .default(false);

export const createAccountValidationSchema = yup.object({
  email,
  acceptTermsAndConditions,
});

// Used for generating password-only validation errors
export const passwordValidationSchema = yup.object({ password });

export const setupPasswordValidationSchema = yup.object({
  password,
  username: email,
});

export const accountDetailsValidationSchema = yup.object({
  username: email,
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  phoneNumber: yup
    .string()
    .phoneNumber('Must be a valid phone number')
    .required('Phone number is required'),
  country: yup
    .number()
    .min(1, 'Country is required')
    .max(253, 'Country is required')
    .required('Country is required'),
});
